<template>
  <f-dashboard-content-layout>
    <template #dashboard-content-side>
      <f-dashboard-content-nav
        v-for="currentNav in currentNavs"
        :key="currentNav.title"
        :links="currentNav.links"
      >
        <template #title>
          <h6>
            <i :class="currentNav.icon"></i>
            <small>{{ currentNav.title }}</small>
          </h6>
        </template>
      </f-dashboard-content-nav>
    </template>

    <template #default>
      <router-view></router-view>
    </template>
  </f-dashboard-content-layout>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useRoles from '@composables/use-roles'
  import router from '@core/router'

  export default {
    setup() {
      const { checkPermissions } = useRoles()

      if (!checkPermissions('freebe/users:find')) {
        router.push({ name: 'home' })
      }

      const userId = computed(() => 
        router.currentRoute.value.params.id
      )
      const entrepreneurId = computed(() => 
        router.currentRoute.value.params.entrepreneur_id || userId.value
      )

      const userNavs = computed(() => [{
        title: 'Utilisateur',
        icon: 'uil uil-user',
        links: [{
          name: 'Profil',
          to: {
            name: 'user-profile',
            params: {
              id: userId.value
            }
          }
        }]
      }, {
        title: 'Entreprises',
        icon: 'uil uil-user',
        permissions: ['freebe/entrepreneurs:get'],
        links: [{
          name: 'Informations',
          to: {
            name: 'entrepreneur-profile',
            params: {
              id: userId.value,
              entrepreneur_id: entrepreneurId.value,
            }
          }
        }, {
          name: 'Activité',
          to: {
            name: 'entrepreneur-activity',
            params: {
              id: userId.value,
              entrepreneur_id: entrepreneurId.value,
            }
          }
        }, {
          name: 'Facturation',
          to: {
            name: 'entrepreneur-billing',
            params: {
              id: userId.value,
              entrepreneur_id: entrepreneurId.value,
            }
          }
        }]
      }, {
        title: 'Abonnements',
        icon: 'uil uil-user',
        permissions: ['freebe/subscriptions:find', 'freebe/mandates:find'],
        links: [{
          name: 'Mandats',
          to: {
            name: 'user-mandate',
            params: {
              id: userId.value
            }
          }
        }, {
          name: 'Souscriptions',
          to: {
            name: 'user-subscription',
            params: {
              id: userId.value
            }
          }
        }]
      }, {
        title: 'Données',
        icon: 'uil uil-user',
        permissions: ['freebe/documents:find'],
        links: [{
          name: 'Documents',
          to: {
            name: 'documents-list',
            params: {
              id: userId.value
            }
          }
        }]
      }])

      const listNavs = [{
        title: 'Users',
        icon: 'uil uil-user',
        links: [
          {
            name: 'Utilisateurs',
            to: {
              name: 'users-list'
            },
            exact: true
          }
        ]
      }]

      function hasPermissions (permissions) {
        return permissions.some(checkPermissions)
      }

      const currentNavs = computed(() => {
        console.log('userId.value', userId.value)
        const navs = userId.value ? userNavs.value : listNavs
        return navs.filter(route => {
          return route.permissions?.length ? hasPermissions(route.permissions) : true
        })
      })

      return {
        currentNavs
      }
    }
  }
</script>
